const state = {
    showPropertyMenu: false,
  };
  
  const getters = {
  
  };
  
  const mutations = {
    togglePropertyMenu (state) {
        state.showPropertyMenu = !state.showPropertyMenu;
    },
  };
  
  const actions = {
    showPropertyMenu ({ commit }) {
        commit('showPropertyMenu');
    }
  };
  
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  };